export default "__VITE_ASSET__vo5OBiBC__"